// src/fareCalculator.js

export const tariffs = {
  one: {
    name: 'Tariff One (Daytime)',
    initialDistanceYards: 328,
    initialFare: 2.55,
    incrementDistanceYards: 176,
    incrementFare: 0.20,
   
  },
  two: {
    name: 'Tariff Two (Night/Weekend)',
    initialDistanceYards: 176,
    initialFare: 3.00,
    incrementDistanceYards: 176,
    incrementFare: 0.25,
   
  },
  three: {
    name: 'Tariff Three (Holiday)',
    initialDistanceYards: 328,
    initialFare: 3.50,
    incrementDistanceYards: 176,
    incrementFare: 0.30,

  },
};

// Global minimum fare (in GBP)
export const MIN_FARE = 5.0;
export const LARGE_PARTY_SURCHARGE = 2.45;
export const LARGE_PARTY_THRESHOLD = 4;

// Smart fare rounding - always rounds DOWN to benefit the customer
export function roundFareDown(fare) {
  if (fare < 10.00) {
    // Under £10: round down to nearest 50p
    return Math.floor(fare * 2) / 2;
  } else {
    // £10 and over: round down to nearest £1
    return Math.floor(fare);
  }
}

const bankHolidays = [
  // 2025 UK Bank Holidays
  '2025-01-01', // New Year's Day
  '2025-04-18', // Good Friday
  '2025-04-21', // Easter Monday
  '2025-05-05',  // Early May Bank Holiday
  '2025-05-26', // Spring Bank Holiday
  '2025-08-25', // Summer Bank Holiday
  '2025-12-25', // Christmas Day
  '2025-12-26', // Boxing Day
  
  // 2026 UK Bank Holidays
  '2026-01-01', // New Year's Day
  '2026-04-03', // Good Friday
  '2026-04-06', // Easter Monday
  '2026-05-04', // Early May Bank Holiday
  '2026-05-25', // Spring Bank Holiday
  '2026-08-31', // Summer Bank Holiday
  '2026-12-25', // Christmas Day
  '2026-12-28', // Boxing Day (substitute day as 26th falls on Saturday)
  
  // Additional special occasions (optional - you can remove these if you don't want holiday rates)
  '2025-12-31', // New Year's Eve
  '2026-12-31', // New Year's Eve
];

export function getApplicableTariff(date = new Date()) {
  const isWeekend = date.getDay() === 0 || date.getDay() === 6;
  const isNight = date.getHours() < 7 || date.getHours() >= 20;
  const dateStr = date.toISOString().split('T')[0];

  if (bankHolidays.includes(dateStr)) return tariffs.three;
  if (isWeekend || isNight) return tariffs.two;
  return tariffs.one;
}

export function calculateFare(distanceYards, tariff, options = {}) {
  const numberOfRiders = Number(options.numberOfRiders || 1);

  if (distanceYards <= tariff.initialDistanceYards) {
    const baseFare = Math.max(tariff.initialFare, MIN_FARE);
    const surcharge = numberOfRiders > LARGE_PARTY_THRESHOLD ? LARGE_PARTY_SURCHARGE : 0;
    return roundFareDown(baseFare + surcharge);
  }

  const remaining = distanceYards - tariff.initialDistanceYards;
  const increments = Math.ceil(remaining / tariff.incrementDistanceYards);
  let rawFare = tariff.initialFare + increments * tariff.incrementFare;
  
  // Add waiting time to trips over 3 miles only
  const distanceMiles = distanceYards / 1760; // Convert yards to miles
  if (distanceMiles > 3) {
    if (tariff.name.includes('Tariff One')) {
      // 3 minutes waiting at £0.20 every 20 seconds = £1.80
      const waitingCharge = (3 * 60 / 20) * 0.20;
      rawFare += waitingCharge;
    } else if (tariff.name.includes('Tariff Two')) {
      // 2 minutes waiting at £0.20 every 25 seconds = £0.96
      const waitingCharge = (2 * 60 / 25) * 0.20;
      rawFare += waitingCharge;
    } else if (tariff.name.includes('Tariff Three')) {
      // 2 minutes waiting at £0.20 every 33.3 seconds = £0.72
      const waitingCharge = (2 * 60 / 33.3) * 0.20;
      rawFare += waitingCharge;
    }
  }

  if (numberOfRiders > LARGE_PARTY_THRESHOLD) {
    rawFare += LARGE_PARTY_SURCHARGE;
  }
  
  return roundFareDown(Math.max(rawFare, MIN_FARE));
}